import { render, staticRenderFns } from "./HalfPageSwitch.vue?vue&type=template&id=3edf47a0&scoped=true&"
import script from "./HalfPageSwitch.vue?vue&type=script&lang=ts&"
export * from "./HalfPageSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf47a0",
  null
  
)

export default component.exports